//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        value: Boolean,
        title: String,
        message: String,
        okLabel: String,
        cancelLabel: String,
        noScrimHide: Boolean,
        noEscHide: Boolean,
    },

    methods: {
        show() {
            this.$refs.dialog.show();
        },
        hide() {
            this.$refs.dialog.hide();
        },
        onHide() {
            this.$emit('hide');
        },
        onOk() {
            this.$emit('ok');
            this.hide();
        },
        onCancel() {
            this.hide();
        },
    },
};
